var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { DataGridRowActionsCell } from './data-grid-row-actions-cell';
import { EntityDataGridRowActions } from '../entities/entity-data-grid-row-actions';
import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';
import { MenuButton } from '../select/menu-button';
import { EllipsisGripButton } from '../select/grip-button';
var cls = classNames('data-grid-row');
export var DataGridRowDefaultProps = {
  menuProps: {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 100%;\n    border-bottom: 1px solid ", ";\n    \n  "], ["\n    height: 100%;\n    border-bottom: 1px solid ", ";\n    \n  "])), theme.COLOR('line-subtle'))
});
var ActionsCellStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: sticky;\n    left: 0;\n    z-index: 2; /* Ensure it stays above other cells */ \n    border-right: 1px solid ", ";\n    width: 45px;\n\n    ", "\n  "], ["\n    position: sticky;\n    left: 0;\n    z-index: 2; /* Ensure it stays above other cells */ \n    border-right: 1px solid ", ";\n    width: 45px;\n\n    ", "\n  "])), theme.COLOR('line-subtle'), function (_a) {
    var isLastRow = _a.isLastRow;
    return isLastRow && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-bottom: none;\n    "], ["\n      border-bottom: none;\n    "])));
  })
});
// -------- Components -------->
var My = {
  NAME: 'DataGridRow',
  Container: styled.tr(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ActionsCell: styled(DataGridRowActionsCell)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ActionsCellStyles)
};
export var DataGridRow = function (props) {
  var componentProps = useComponentProps(My.NAME, DataGridRowDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    onMenuItemSelect = componentProps.onMenuItemSelect,
    isSortable = componentProps.isSortable,
    menuProps = componentProps.menuProps,
    onActionsClick = componentProps.onActionsClick,
    menu = componentProps.menu,
    id = componentProps.id,
    isUpdated = componentProps.isUpdated,
    isError = componentProps.isError,
    isAdded = componentProps.isAdded,
    isLast = componentProps.isLast;
  var THEME = useTheme();
  var _a = useSortable({
      id: id
    }),
    attributes = _a.attributes,
    listeners = _a.listeners,
    isDragging = _a.isDragging,
    setNodeRef = _a.setNodeRef,
    transform = _a.transform,
    transition = _a.transition;
  var style = {
    transform: CSS.Transform.toString(transform),
    transition: transition
  };
  var actions = props.actions || React.createElement(EntityDataGridRowActions, {
    menuButton: React.createElement(MenuButton, __assign({}, attributes, listeners, {
      buttonComponent: !isSortable ? EllipsisGripButton : undefined,
      menu: menu,
      menuProps: menuProps,
      onMenuItemSelect: onMenuItemSelect
    }))
  });
  var actionsCellColors = {
    background: 'subtle-chrome'
  };
  if (isAdded) {
    actionsCellColors.background = 'subtle-chrome-add';
  } else if (isUpdated) {
    // actionsCellColors.background = 'subtle-chrome-update';
  } else if (isError) {
    actionsCellColors.background = 'subtle-chrome-error';
  }
  var actionsCellTitle = isAdded ? 'New Item' : isUpdated ? 'Updated Item' : isError ? 'Error' : undefined;
  return React.createElement(My.Container, {
    ref: setNodeRef,
    style: style,
    isDragging: isDragging,
    className: cls.name(className)
  }, React.createElement(My.ActionsCell, {
    onClick: onActionsClick,
    isLastRow: isLast,
    title: actionsCellTitle,
    colors: actionsCellColors,
    actions: actions
  }), children);
};
DataGridRow.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;